import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getClearStatusLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const ClearStatusHistory = () => {
  const [clearStatusHistory, setClearStatusHistory] = useState([]);
  const { reset_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getClearStatusLog(reset_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setClearStatusHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Clear Status Log
        </Typography>
      </Box>

      {response && clearStatusHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ICCID</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">
                      {clearStatusHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/tmobilej/clear_status/batch/${clearStatusHistory.data.batch_id}`}
                      >
                        {clearStatusHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={clearStatusHistory.data.status}
                        size="small"
                        color={getChipColor(clearStatusHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {clearStatusHistory.data.last_updated &&
                        format(
                          new Date(clearStatusHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={clearStatusHistory.history?.data || []} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ClearStatusHistory;
